import request from "@/CommonDP/service/webShare-service";
import { tableRowIcon, filePreviewV1, viewH5FileMethods } from "@/CommonDP/utils/docPublic";
// import { getEnterpriseId } from "@/CommonDP/utils/auth";
import { iosQQ, isMobile, getapptoux } from "@/CommonDP/utils";

export default {
  data() {
    return {
      shareSource: '',
      allMessage: "",
      enterpriseId: ''
    };
  },
  mounted() {
    this.shareInit();
  },
  computed: {
    resDataBoolean() {
      const id = iosQQ() ? decodeURIComponent(encodeURIComponent(this.$route.query.i)) : encodeURIComponent(this.$route.query.i);
      return isMobile() && JSON.parse(localStorage.getItem("AppShare"))?.queryI && JSON.parse(localStorage.getItem("AppShare"))?.queryI === id;
    },
    locationAppData() {
      return JSON.parse(localStorage.getItem("AppShare"));
    }
  },
  methods: {
    async shareInit() {
      this.loadBoolean = true;
      const id = iosQQ() ? decodeURIComponent(encodeURIComponent(this.$route.query.i)) : encodeURIComponent(this.$route.query.i);
      const res = await request.getSharedetail(id);
      const data = this.resDataBoolean ? this.locationAppData : res.data;
      this.commonData(data);
    },
    async extractBtn() {
      const id = iosQQ() ? decodeURIComponent(encodeURIComponent(this.$route.query.i)) : encodeURIComponent(this.$route.query.i);
      const pwd = this.code;
      try {
        const res = await request.queryPwdShare(id, pwd);
        const data = res.data;
        if (isMobile()) {
          const shareObj = {
            ...res.data,
            queryI: id
          };
          localStorage.setItem('AppShare', JSON.stringify(shareObj));
        }
        this.commonData(data);
        this.isNeedPwd = "";
      } catch (error) {
        if (error.data.result === '3') {
          this.$message.error(error.data.message);
        } else {
          console.log(error);
        }
      }
    },
    commonData(data) {
      const isSuccess = data.isSuccess;
      if (isSuccess === 1) {
        return this.$message.warning("文件不存在");
      } else if (isSuccess === 2) {
        this.isNeedPwd = "";
        this.isTimeOu = true;
        return;
      } else if (isSuccess === 3) {
        return this.$message.warning("密码错误");
      }
      this.isNeedPwd = data.isNeedPwd;
      this.shareArr = data.list;
      this.backupsArr = data.list;
      this.argument.prjId = data.prjId;
      this.argument.userId = data.operUserId;
      this.isDownload = data.isDownload;
      this.shareSource = data.shareSource;
      this.enterpriseId = data.enterpriseId;
      this.allMessage = this.getUserObj(data);
      const obj = {
        name: '共享文件',
        list: data.list
      };
      this.navList = [obj];
      this.loadBoolean = false;
      // this.getShareToken();
    },
    async getShareToken() {
      const id = iosQQ() ? decodeURIComponent(encodeURIComponent(this.$route.query.i)) : encodeURIComponent(this.$route.query.i);
      const res = await request.getShareToken(id);
      this.shareToken = res.data;
    },
    async clickFolderOrFile(row, type) {
      const { operUserId } = row;
      if (row.isFile === 1 || row.isFolder === 1) { // 如果是文件夹 就直接下一级
        this.loadBoolean = true;
        this.queryDocShareList(row);
      } else {
        if (type === 'web') {
          const data = {
            fileType: row.fileType,
            fileId: row.folderId,
            versionId: row.fileVersion || 1,
            flowInstanceId: this.flowInstanceId,
            sharerId: operUserId || this.allMessage.operUserId,
            i: this.$route.query.i,
            status: row.status,
            parentId: row.parentId
          };
          filePreviewV1(data, this.shareArr);
        } else {
          const params = {
            fileId: row.folderId,
            versionId: row.fileVersion,
            sharerId: operUserId || this.allMessage.operUserId,
            i: this.$route.query.i
          };
          viewH5FileMethods(row, params);
        }
      }
    },
    async queryDocShareList(row) {
      const { prjId } = this.argument;
      const id = iosQQ() ? decodeURIComponent(encodeURIComponent(this.$route.query.i)) : encodeURIComponent(this.$route.query.i);
      const { operUserId, folderId } = row;
      const params = {
        userId: operUserId,
        folderId,
        isRead: 1,
        priviAll: "1",
        prjId: prjId,
        versionId: "",
        enterpriseId: this.enterpriseId,
        shareSource: this.shareSource
      };
      const res = await request.docShareList(id, params);
      this.shareArr = res.data;
      this.loadBoolean = false;
      const obj = {
        name: row.folderName,
        list: res.data || []
      };
      this.navList.push(obj);
    },
    // 返回某一层级
    clickBread (item, index) {
      this.loadBoolean = true;
      this.navList = this.navList.slice(0, index + 1);
      this.shareArr = item.list;
      this.loadBoolean = false;
    },
    getUserObj(obj) {
      const img = getapptoux(obj.operUserId);
      if (img) {
        obj.img = img;
      } else {
        obj.tox = obj.operUserName.charAt(0);
      }
      return obj;
    },
    nameIcon(row) {
      // 因为接口/doc/shareNew/detail 没有相应的数据 故所有的文件夹都用同一个图标
      if (row.fileType === 10 && (row.isFolder === 1 || (row.delPrivi && row.folderType === 0) || row.isRelaFolder === 1 || row.isFile === 10 || row.isFile === 1)) {
        return require(`@/CommonDP/assets/projectMg/treewenjianjia.png`);
      } else {
        return tableRowIcon(row);
      }
    }
  }
};
